<template>
  <v-app>
    <v-navigation-drawer
      v-if="this.$route.name != 'Login'"
      v-model="drawer"
      enable-resize-watcher
      :mini-variant.sync="mini"
      permanent
      :width="290"
      class="menu"
      app>
      <div class="ui-relative">
        <div class="text-center" v-if="!$vuetify.theme.dark">
          <img class="menu__open" @click.stop="toggleMenu()" v-if="!mini" src="./assets/img/logo.png" alt="Logo">
          <img class="menu__icon" v-if="mini" src="./assets/img/logo-icon.png" alt="Logo">
        </div>
        <div class="text-center" v-else>
          <img class="menu__open" @click.stop="toggleMenu()" v-if="!mini" src="./assets/img/logo-white.png" alt="Logo">
          <img class="menu__icon" v-if="mini" src="./assets/img/logo-white-icon.png" alt="Logo">
        </div>
        <div :class="!mini ? 'tipo' : 'tipo_small'">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" @click="verificaTipoUsuario()" :class="nivelUsuarioApelido !== 'M' ? 'cursor-pointer' : ''">
                {{!mini ? nivelUsuario : nivelUsuarioApelido}}
              </div>
            </template>
            <span>Nível do usuário</span>
          </v-tooltip>
        </div>
      </div>
      <v-list expand dense>
        <v-list-item link to="/" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['inicio:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>home</v-icon>
              </v-list-item-icon>
            </template>
            <span>Início</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Início</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/visao-geral" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['visao-geral:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>visibility</v-icon>
              </v-list-item-icon>
            </template>
            <span>Visão geral</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Visão geral</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/chamados" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['chamados:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>support_agent</v-icon>
              </v-list-item-icon>
            </template>
            <span>Chamados</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Chamados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/acompanhamento-usina" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['acompanhamento-das-usinas:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>solar_power</v-icon>
              </v-list-item-icon>
            </template>
            <span>Acompanhamento das Usinas</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Acompanhamento das Usinas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/status-das-usinas" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['status-das-usinas:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>monitor_heart</v-icon>
              </v-list-item-icon>
            </template>
            <span>Status das Usinas</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Status das Usinas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/status-dos-inversores" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['status-dos-inversores:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>bolt</v-icon>
              </v-list-item-icon>
            </template>
            <span>Status dos Inversores</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Status dos Inversores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          v-model="subgroupCad"
          append-icon="keyboard_arrow_down"
          v-if="$root.Permissions.validate(['cadastros:visualizar'])"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>group_add</v-icon>
                </v-list-item-icon>
              </template>
              <span>Cadastros</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupCad = !subgroupCad">
              <v-list-item-title>Cadastros</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="/cadastros/integrador" @click.stop="toggleMenu()" v-if="!user.fk_int_id_integrador && $root.Permissions.validate(['integradores:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Integradores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/cadastros/distribuidor" @click.stop="toggleMenu()" v-if="!user.fk_int_id_integrador && !user.fk_dis_id_distribuidor && $root.Permissions.validate(['distribuidores:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Distribuidores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/cadastros/cliente" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['clientes:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Clientes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/cadastros/usina" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['usinas:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usinas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/cadastros/unidade-consumidora" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['unidades-consumidoras:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Unidades Consumidoras</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/cadastros/concessionaria" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['concessionarias:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Concessionárias</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/cadastros/inversores" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['inversores:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Inversores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item link to="/auditoria" @click.stop="toggleMenu()" v-if="nivelUsuarioApelido == 'M'">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>manage_search</v-icon>
              </v-list-item-icon>
            </template>
            <span>Auditoria</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Auditoria</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/log" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['log:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>history</v-icon>
              </v-list-item-icon>
            </template>
            <span>Log de Sistema</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Log de Sistema</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/relatorios" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['relatorios:visualizar'])">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on" @click="mini = false">
                <v-icon>feed</v-icon>
              </v-list-item-icon>
            </template>
            <span>Relatórios</span>
          </v-tooltip>
          <v-list-item-content>
            <v-list-item-title>Relatórios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-if="$root.Permissions.validate(['administracao:visualizar'])"
          v-model="subgroupGest"
          append-icon="keyboard_arrow_down"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>engineering</v-icon>
                </v-list-item-icon>
              </template>
              <span>Gestor</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupGest = !subgroupGest">
              <v-list-item-title>Gestor</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="/gestor/grupos" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['grupos-de-usuarios:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Grupos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/gestor/usuarios" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['usuarios:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-model="subgroupConf"
          append-icon="keyboard_arrow_down"
          v-if="$root.Permissions.validate(['configuracoes:visualizar'])"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon v-bind="attrs" v-on="on">
                  <v-icon>settings</v-icon>
                </v-list-item-icon>
              </template>
              <span>Configurações</span>
            </v-tooltip>
            <v-list-item-content @click.stop="subgroupConf = !subgroupConf">
              <v-list-item-title>Configurações</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="/configuracoes/discord" @click.stop="toggleMenu()" v-if="user.uuid_dis_id || user.uuid_int_id && $root.Permissions.validate(['discord:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Discord</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/osticket" @click.stop="toggleMenu()" v-if="user.uuid_dis_id || user.uuid_int_id && $root.Permissions.validate(['discord:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Osticket</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/configuracoes-gerais" @click.stop="toggleMenu()" v-if="$root.Permissions.validate(['configuracoes-gerais:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Configurações Gerais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/chamados" @click.stop="toggleMenu()" v-if="user.uuid_dis_id || user.uuid_int_id && $root.Permissions.validate(['configuracoes-chamados:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Chamados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/chat" @click.stop="toggleMenu()" v-if="user.uuid_dis_id && $root.Permissions.validate(['chat:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Chat</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/app" @click.stop="toggleMenu()" v-if="user.uuid_int_id && $root.Permissions.validate(['configuracoes-app:visualizar'])">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>APP</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- v-if="user.uuid_int_id && $root.Permissions.validate(['configuracoes-app-usuarios:visualizar'])"" -->
          <v-list-item link to="/configuracoes/app-usuarios" @click.stop="toggleMenu()">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usuários de Integração</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/configuracoes/imposto" @click.stop="toggleMenu()">
            <v-list-item-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Impostos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <div class="versao">
        1.0.65
      </div>
    </v-navigation-drawer>
    <v-app-bar
      v-if="this.$route.name != 'Login'"
      class="menu__toolbar"
      app
      :height="bgHeight"
      :absolute="true">
      <div class="w-100">
        <v-row no-gutters justify="end" align="center">
          <div class="mr-3 formBuscaArea">
            <v-form ref="formBusca" style="min-height: 40px">
              <!-- <v-text-field
                v-model="busca"
                outlined
                label="Busca"
                append-icon="search"
                hide-details="auto"
              ></v-text-field> -->
            </v-form>
          </div>
          <div class="mr-3">
            <v-row no-gutters align="center">
              <notificacao class="ui-btn-inherit ml-3"></notificacao>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Bem-vindo, {{user ? user.usu_nome.length > 25 ? user.usu_nome.substring(0,25) + '...' : user.usu_nome : ''}}
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="dialogDadosEmpresa = true" v-if="exibirEmpresa">
                    <v-list-item-icon class="mr-1">
                      <v-icon>account_balance</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Dados da empresa</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="dialogCadastro = true">
                    <v-list-item-icon class="mr-1">
                      <v-icon>manage_accounts</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Atualizar meu cadastro</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="dialogPassword = true">
                    <v-list-item-icon class="mr-1">
                      <v-icon>lock_reset</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Alterar senha</v-list-item-title>
                  </v-list-item> -->
                  <v-list-item @click="dialogLogout = true">
                    <v-list-item-icon class="mr-1">
                      <v-icon>logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Sair</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </div>
        </v-row>
      </div>
        <v-dialog
        v-model="dialogDadosEmpresa"
        persistent
        max-width="800px"
      >
        <v-card class="ui-dialog-top">
          <v-row no-gutters align="center" justify="space-between">
            Dados da empresa
            <v-icon @click="dialogDadosEmpresa = false">close</v-icon>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formDadosEmpresa">
            <v-row>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field
                  outlined
                  readonly
                  label="Nome"
                  :value="dadosEmpresa.nome"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field
                  outlined
                  readonly
                  label="Nome Fantasia"
                  :value="dadosEmpresa.nome_fantasia"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
                <v-text-field-cnpj
                  label="CNPJ"
                  v-bind:properties="{
                    readonly: true,
                    outlined: true,
                    placeholder: '',
                  }"
                  v-bind:options="{
                    outputMask: '##############',
                    empty: null,
                    applyAfter: false,
                  }"
                  :value="dadosEmpresa.cnpj"
                ></v-text-field-cnpj>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pb-0 pt-0">
                <v-text-field-cep
                  label="CEP"
                  v-bind:properties="{
                    readonly: true,
                    outlined: true,
                    placeholder: '',
                  }"
                  v-bind:options="{
                    outputMask: '########',
                    empty: null,
                    applyAfter: false,
                  }"
                  :value="dadosEmpresa.cep"
                ></v-text-field-cep>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Estado"
                  :value="dadosEmpresa.estado"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Cidade"
                  :value="dadosEmpresa.cidade"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Bairro"
                  :value="dadosEmpresa.bairro"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Rua"
                  :value="dadosEmpresa.rua"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Número"
                  :value="dadosEmpresa.numero"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Complemento"
                  :value="dadosEmpresa.complemento"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Telefone"
                  :value="dadosEmpresa.telefone"
                  v-mask="'(##) #####-####'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="Celular"
                  :value="dadosEmpresa.celular"
                  v-mask="'(##) #####-####'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
                <v-text-field
                  outlined
                  readonly
                  label="E-mail"
                  :value="dadosEmpresa.email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0" v-if="dadosEmpresa.apiUrl">
                <v-text-field
                  outlined
                  readonly
                  label="API URL"
                  :value="dadosEmpresa.apiUrl"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0" v-if="dadosEmpresa.login">
                <v-text-field
                  outlined
                  readonly
                  label="Login"
                  :value="dadosEmpresa.login"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0" v-if="dadosEmpresa.senha">
                <v-text-field
                  outlined
                  readonly
                  label="Senha"
                  :value="dadosEmpresa.senha"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0 mb-8" v-if="dadosEmpresa.imagem">
                <div class="ui-avatar" :style="`background-image: url('${dadosEmpresa && dadosEmpresa.imagem ? dadosEmpresa.imagem : require('@/assets/img/logo-icon.png')}')`"></div>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              @click="dialogDadosEmpresa = false"
            >
              Fechar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogPassword"
        persistent
        max-width="600px"
      >
        <v-card class="ui-dialog-top">
          <v-row no-gutters align="center" justify="space-between">
            Alterar senha
            <v-icon @click="cancelarNovaSenha()">close</v-icon>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <div class="text text--thin mb-3">
            Preencha a nova senha nos campos abaixo:
          </div>
          <v-form ref="formPassword">
            <v-row>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <v-text-field
                  @click:append="showPassword = !showPassword"
                  autofocus
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'remove_red_eye' : 'visibility_off'"
                  v-model="usuario.password"
                  outlined
                  required=""
                  hint="Mínimo 6 caracteres"
                  counter
                  :rules="[rules.required, rules.min6]"
                  label="Senha*"
                  :disabled="salvandoPassword"
                  :loading="salvandoPassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <v-text-field
                  @click:append="showRepeatPassword = !showRepeatPassword"
                  :type="showRepeatPassword ? 'text' : 'password'"
                  :append-icon="showRepeatPassword ? 'remove_red_eye' : 'visibility_off'"
                  v-model="usuario.passwordRepeat"
                  outlined
                  required=""
                  hint="Mínimo 6 caracteres"
                  counter
                  :rules="confirmPasswordRules"
                  label="Repita Senha*"
                  :disabled="salvandoPassword"
                  :loading="salvandoPassword"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :disabled="salvandoPassword"
              @click="cancelarNovaSenha()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="confirmaAlterarSenha()"
              :loading="salvandoPassword"
              :disabled="salvandoPassword"
            >
              Alterar senha
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConfirmar" max-width="400">
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Tem certeza que deseja alterar sua senha?
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="cancelarNovaSenha()">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-row
            align="center"
            justify="space-between"
            class="px-5 py-5"
          >
            <v-btn
              color="cancel"
              :disabled="salvandoPassword"
              :loading="salvandoPassword"
              @click="cancelarNovaSenha()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              :disabled="salvandoPassword"
              :loading="salvandoPassword"
              @click="atualizarSenha()"
            >
              Alterar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLogout" max-width="450">
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Tem certeza que deseja sair?
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="dialogLogout = false">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-row
            align="center"
            justify="space-between"
            class="px-5 py-5"
          >
            <v-btn
              color="cancel"
              :disabled="logoutLoading"
              :loading="logoutLoading"
              @click="dialogLogout = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              :disabled="logoutLoading"
              :loading="logoutLoading"
              @click="logout()"
            >
              Sair
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogCadastro"
        persistent
        max-width="400px"
      >
        <v-card class="ui-dialog-top">
          <v-row no-gutters align="center" justify="space-between">
            Atualizar meu cadastro
            <v-icon @click="closeDialogUsuario()">close</v-icon>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <v-form ref="formCadastro">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
                <v-text-field
                  v-model="usuario.usu_nome"
                  label="Nome*"
                  :rules="[rules.required]"
                  autofocus
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="usuario.usu_email"
                  label="E-mail*"
                  :rules="[rules.required]"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
                <v-text-field
                  v-model="usuario.usu_apelido"
                  label="Usuário*"
                  :rules="[rules.required]"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0">
                <v-text-field
                  @click:append="show1 = !show1"
                  :label="usuario.uuid_usu_id ? 'Preencha caso desejar alterar a senha' : 'Senha*'"
                  hint="Mínimo 6 caracteres"
                  counter
                  outlined
                  :loading="salvando"
                  :disabled="salvando"
                  :type="show1 ? 'text' : 'password'"
                  v-model="usuario.password"
                  :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                  :rules="usuario.uuid_usu_id ? [] : [rules.required, rules.min]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
                <v-file-input
                  show-size
                  clearable
                  ref="file"
                  v-model="usuario.usu_imagem"
                  prepend-icon="image"
                  label="Adicionar imagem"
                  clear-icon="close"
                  truncate-length="50"
                  :loading="salvando"
                  :disabled="salvando"
                  v-if="isObject(usuario.usu_imagem)"
                  outlined
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usuario.usu_imagem && !isObject(usuario.usu_imagem)">
                <v-row no-gutters justify="start" align="center">
                  <div>
                    <div class="avatar" :style="`background-image: url('${usuario && usuario.usu_imagem ? usuario.usu_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                  </div>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                      </template>
                      <span>Remover imagem</span>
                    </v-tooltip>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
          <v-divider></v-divider>
          <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
            <v-btn
              color="cancel"
              :loading="salvando"
              :disabled="salvando"
              @click="closeDialogUsuario()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              @click="editUser()"
              :loading="salvando"
            :disabled="salvando"
            >
              Salvar
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    </v-app-bar>
    <v-main :class="this.$route.name != 'Login' ? 'main__home' : ''">
      <div id="app" class="h-100" @click="checkMenuOpen()">
        <transition name="route-fade" mode="out-in">
          <router-view/>
        </transition>
      </div>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <div class="theme" v-bind="attrs" v-on="on">
            <v-icon @click="setTheme" v-if="!theme">brightness_5</v-icon>
            <v-icon @click="setTheme" v-else>brightness_4</v-icon>
          </div>
        </template>
        <span>Alterar tema</span>
      </v-tooltip>
    </v-main>
    <snack-bar v-if="toggleSnack" />
    <printer :control="togglePrinter" />
  </v-app>
</template>

<script>
import SnackBar from '@components/SnackBar.vue'
import Printer from '@components/Printer.vue'
import Api from '@API'
import Notificacao from './pages/Notificacao.vue'

export default {
  components: {SnackBar, Notificacao, Printer},
  data () {
    return {
      theme: false,
      drawer: true,
      mini: true,
      bgHeight: '60',
      busca: '',
      dialogPassword: false,
      dialogConfirmar: false,
      dialogCadastro: false,
      exibirEmpresa: false,
      dialogDadosEmpresa: false,
      dialogLogout: false,
      user: '',
      showPassword: false,
      logoutLoading: false,
      showRepeatPassword: false,
      salvandoPassword: false,
      salvandoCadastro: false,
      subgroupCad: false,
      subgroupGest: false,
      subgroupConf: false,
      nivelUsuarioApelido: '',
      dialogDeletarImagem: false,
      dadosEmpresa: [],
      show1: false,
      chat: null,
      usuario: {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        usu_imagem: '',
        password: ''
      },
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => !!(v.split(' ').length > 1 & v.split(' ')[1] !== '') || 'Obrigatório nome e sobrenome',
        min6: value => !!value[5] || 'minimo 6 caracteres.'
      },
      confirmPasswordRules: [
        (value) => !!value || 'Confirme a senha',
        (value) =>
          value === this.usuario.password || 'A confirmação da senha não corresponde.'
      ],
      salvando: false
    }
  },
  methods: {
    toggleMenu () {
      this.mini = !this.mini
      this.subgroupCad = false
      this.subgroupGest = false
      this.subgroupConf = false
    },
    setTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.theme = this.$vuetify.theme.dark
      localStorage.setItem('darkTheme', this.$vuetify.theme.dark.toString())
    },
    checkMenuOpen () {
      if (!this.mini) {
        this.toggleMenu()
      }
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    confirmaAlterarSenha () {
      if (!this.$refs.formPassword.validate()) return
      this.dialogConfirmar = true
    },
    atualizarSenha () {
      this.salvandoPassword = true
      this.dialogConfirmar = false
      setTimeout(() => {
        this.salvandoPassword = false
        this.cancelarNovaSenha()
      }, 3000)
    },
    getDadosEmpresa () {
      let endpoint = ''
      let tipo = 0
      if (this.user.uuid_int_id) {
        endpoint = 'integradores/' + this.user.uuid_int_id
        tipo = 1
      } else if (this.user.uuid_dis_id) {
        endpoint = 'distribuidores/' + this.user.uuid_dis_id
        tipo = 2
      }
      if (endpoint) {
        Api.get(endpoint)
          .then((response) => {
            this.salvando = false
            if (response.data.error) {
              this.$root.SnackControl.open(this, {
                text: response.data.error,
                color: 'error'
              })
              return false
            }
            if (tipo === 1) {
              this.dadosEmpresa = {
                nome: response.data.int_nome,
                nome_fantasia: response.data.int_nome_fantasia,
                cnpj: response.data.int_cnpj,
                estado: response.data.int_uf,
                cidade: response.data.int_cidade,
                bairro: response.data.int_bairro,
                rua: response.data.int_rua,
                cep: response.data.int_cep,
                numero: response.data.int_numero,
                complemento: response.data.int_complemento,
                telefone: response.data.int_telefone,
                celular: response.data.int_celular,
                email: response.data.int_email,
                imagem: response.data.int_imagem
              }
            }
            if (tipo === 2) {
              this.dadosEmpresa = {
                nome: response.data.dis_nome,
                nome_fantasia: response.data.dis_nome_fantasia,
                cnpj: response.data.dis_cnpj,
                estado: response.data.dis_uf,
                cidade: response.data.dis_cidade,
                bairro: response.data.dis_bairro,
                rua: response.data.dis_rua,
                cep: response.data.dis_cep,
                numero: response.data.dis_numero,
                complemento: response.data.dis_complemento,
                telefone: response.data.dis_telefone,
                celular: response.data.dis_celular,
                email: response.data.dis_email,
                imagem: response.data.dis_imagem,
                apiUrl: response.data.dis_api_url,
                login: response.data.dis_api_login,
                senha: response.data.dis_api_senha
              }
            }
          })
          .catch((error) => {
            this.salvando = false
            this.$root.SnackControl.open(this, {
              text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do usuário!',
              color: 'error'
            })
          })
      }
    },
    cancelarNovaSenha () {
      this.usuario.password = ''
      this.usuario.passwordRepeat = ''
      this.dialogConfirmar = false
      this.$refs.formPassword.resetValidation()
      this.dialogPassword = false
    },
    verificaTipoUsuario () {
      if (this.nivelUsuarioApelido === 'D' || this.nivelUsuarioApelido === 'I') {
        this.dialogDadosEmpresa = true
      }
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        this.usuario = this.user
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuario = 'Master'
          this.nivelUsuarioApelido = 'M'
          this.exibirEmpresa = false
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuario = 'Distribuidor'
          this.nivelUsuarioApelido = 'D'
          this.getDadosEmpresa()
          this.exibirEmpresa = true
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuario = 'Integrador'
          this.nivelUsuarioApelido = 'I'
          this.getDadosEmpresa()
          this.exibirEmpresa = true
        }
      }
    },
    logout () {
      this.logoutLoading = true
      Api.post('usuario/logout')
        .then(res => {
          console.log(res)
          this.dialog = false
          localStorage.removeItem('userData')
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          this.dialogLogout = false
          this.logoutLoading = false
          this.user = null
          this.$router.push({ name: 'Login' }).catch(() => {})
        })
        .catch(err => {
          this.dialogLogout = false
          this.logoutLoading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao efetuar o logout!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagem () {
      this.usuario.usu_imagem = ''
      this.usuario.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    editUser () {
      if (!this.$refs.formCadastro.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      if (this.$refs.file) {
        this.usuario.imagem = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.usuario).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.usuario.usu_imagem[0].file)
            }
          }
        } else {
          if (this.usuario[key] != null) {
            formData.append(key, this.usuario[key])
          }
        }
      })
      Api.post('usuarios/edita', formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogUsuario()
          this.user = response.data
          this.usuario = response.data
          localStorage.setItem('user', JSON.stringify(response.data))
          this.$root.SnackControl.open(this, {
            text: 'Usuário atualizado com sucesso!',
            color: 'success'
          })
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogUsuario () {
      if (this.$refs.formCadastro) {
        this.$refs.formCadastro.resetValidation()
      }
      // this.usuario = {
      //   uuid_gru_id: '',
      //   usu_nome: '',
      //   usu_email: '',
      //   usu_apelido: '',
      //   password: ''
      // }
      this.dialogCadastro = false
    },
    goToUser () {
      this.$router.push('/gestor/usuarios').catch(() => {})
      this.checkMenuOpen()
    },

    async getChat () {
      let user = JSON.parse(localStorage.getItem('user'))
      let dados = {
        uuid_dis_id: user.uuid_dis_id ? user.uuid_dis_id : user.uuid_usu_id
      }
      await Api.post('configuracao/chat', dados)
        .then(res => {
          this.chat = res.data
          if (this.chat && this.chat.script) {
            let script = document.createElement('script')

            if (this.chat.coc_script_chat.indexOf('src') > 0) {
              script.src = this.chat.script
            } else {
              script.append(this.chat.script)
            }

            document.body.appendChild(script)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  computed: {
    toggleSnack () {
      return this.$root.snackbar.show
    },
    togglePrinter () {
      return this.$root.printerControl.show
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    const theme = localStorage.getItem('darkTheme')
    if (theme) {
      if (theme === 'true') {
        this.$vuetify.theme.dark = true
        this.theme = true
      } else {
        this.$vuetify.theme.dark = false
        this.theme = false
      }
    } else if (
      window.matchMedia &&
       window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      this.$vuetify.theme.dark = true
      localStorage.setItem(
        'darkTheme',
        this.$vuetify.theme.dark.toString()
      )
    }
    this.$router.beforeEach((to, from, next) => {
      this.subgroupAdm = false
      this.subgroupAtd = false
      this.subgroupEst = false
      this.subgroupFin = false
      this.subgroupTar = false
      this.subgroupRel = false
      this.showPage = false
      next()
    })
    this.updateData()
    this.getChat()
  }
}
</script>

<style lang="scss">
@import "@scss/app.scss";
.theme {
  bottom: 10px;
  left: 16px;
  position: fixed;
  z-index: 10;
}
.menu {
  &__icon {
    margin-top: 15px;
    max-width: 35px;
  }
  &__open {
    margin-top: 15px;
  }
}
@media (max-width: 767px){
  .formBuscaArea {
    display: none;
  }
}
.tipo {
  background: $primary;
  border-radius: 5px;
  cursor: default;
  font-size: 14px;
  left: 135px;
  line-height: normal;
  padding: 0px 5px;
  position: absolute;
  top: 70px;
  transition: all 0.3s;
}
.tipo_small {
  background: $primary;
  border-radius: 5px;
  cursor: default;
  font-size: 14px;
  left: 30px;
  line-height: normal;
  padding: 2px 5px 1px 5px;
  position: absolute;
  top: 35px;
  transition: all 0.3s;
}
.versao {
  bottom: 0px;
  font-size: 9px;
  left: 1px;
  position: absolute;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
@media print {
  .menu__toolbar {
    display: none;
  }
  .menu {
    display: none;
  }
  .theme {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue